import { render, staticRenderFns } from "./ReturnInvice.vue?vue&type=template&id=01924f57&scoped=true"
import script from "./ReturnInvice.vue?vue&type=script&lang=js"
export * from "./ReturnInvice.vue?vue&type=script&lang=js"
import style0 from "./ReturnInvice.vue?vue&type=style&index=0&id=01924f57&prod&scoped=true&lang=css"
import style1 from "./ReturnInvice.vue?vue&type=style&index=1&id=01924f57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01924f57",
  null
  
)

export default component.exports